import React from 'react';

interface ScaleLabelsProps {
  low?: string;
  mid?: string;
  high?: string;
}

const ScaleLabels: React.FC<ScaleLabelsProps> = ({ low, mid, high }) => {
  if (!low && !mid && !high) return null;
  return (
    <div className="scale-labels">
      <span>{low}</span>
      {mid && <span>{mid}</span>}
      <span>{high}</span>
    </div>
  );
};

export default ScaleLabels;
